module.exports = __webpack_public_path__ + "img/late-tortoise.48242810.webp";